import {
    ComparativeMetric,
    ComparativeNormalization
} from "@dropDesk/domain/entities/reports/report_ticket_comparative/comparative_metric.entity";
import {
    ComparativeMetricsGroup
} from "@dropDesk/domain/entities/reports/report_ticket_comparative/report_ticket_comparative.entity";
import {
    ReportTicketAggregateEntity
} from "@dropDesk/domain/entities/reports/report_ticket_aggregate/report_ticket_aggregate.entity";

const wrapMetric = (current: number): ComparativeMetric => {
    return new ComparativeMetric({
        current: Number(current ?? 0),
        previous: 0,
        variationPercent: 0,
        direction: 'stable',
        isImprovement: true,
    });
};

export const buildMetricsFromAggregate = (
    data: ReportTicketAggregateEntity,
    period: Array<Date>,
): {
    metrics: ComparativeMetricsGroup;
    normalization: ComparativeNormalization;
} => {
    const startMs = period[0].getTime();
    const endMs = period[1].getTime();
    const durationHours = Math.max((endMs - startMs) / (1000 * 60 * 60), 1 / 60);
    const durationDays = Math.max(durationHours / 24, 1 / 24);
    const normalization: ComparativeNormalization = durationHours <= 24 ? 'hourly' : 'daily';
    const divisor = normalization === 'hourly' ? durationHours : durationDays;
    const averagePerUnit = data.totalTickets / divisor;

    return {
        normalization,
        metrics: new ComparativeMetricsGroup({
            timeFirstResponse: wrapMetric(data.timeFirstResponseAggregate),
            timeResolution: wrapMetric(data.timeResolutionAggregate),
            totalTickets: wrapMetric(data.totalTickets),
            averagePerUnit: wrapMetric(averagePerUnit),
            averageRating: wrapMetric(data.averageRating),
            ticketsInBusinessHour: wrapMetric(data.ticketsInBusinessHour),
            ticketsOutBusinessHour: wrapMetric(data.ticketsOutBusinessHour),
        }),
    };
};
